var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:stars"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.66602 1.33398L8.34602 5.00065L11.9993 6.66732L8.34602 8.34732L6.66602 12.0007L4.99935 8.34732L1.33268 6.66732L4.99935 5.00065M19.9993 5.33398L23.3327 12.6673L30.666 16.0007L23.3327 19.334L19.9993 26.6673L16.666 19.334L9.33268 16.0007L16.666 12.6673M6.66602 20.0007L8.34602 23.654L11.9993 25.334L8.34602 27.0007L6.66602 30.6673L4.99935 27.0007L1.33268 25.334L4.99935 23.654",
    fill: "url(#paint0_linear_1857_25850)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1857_25850",
    x1: 15.9993,
    y1: 1.33398,
    x2: 15.9993,
    y2: 30.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#139107"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.3185fd171833c23dcf692ad480bcb685.svg";
export { ForwardRef as ReactComponent };